export enum MotivoRequerimentoEnum {
  PRIMEIRO_VALOR = 1,
  SEGUNDO_VALOR = 2,
  TERCEIRO_VALOR = 3,
  QUARTO_VALOR = 4,
  QUINTO_VALOR = 5,
  SEXTO_VALOR = 6,
}

export const MotivoRequerimentoEnumDescricao = {
  [MotivoRequerimentoEnum.PRIMEIRO_VALOR]: 'Apreciação do pedido liminar',
  [MotivoRequerimentoEnum.SEGUNDO_VALOR]: 'Pedido de homologação de acordo',
  [MotivoRequerimentoEnum.TERCEIRO_VALOR]: 'Pedido de desistência do recurso',
  [MotivoRequerimentoEnum.QUARTO_VALOR]: 'Pedido para certificar o trânsito em julgado',
  [MotivoRequerimentoEnum.QUINTO_VALOR]: 'Pedido de inclusão em pauta de julgamento',
  [MotivoRequerimentoEnum.SEXTO_VALOR]: 'Pedido de desarquivamento',
};

// Exemplo de uso:
export function obterDescricaoEnum(valor: MotivoRequerimentoEnum): string {
  return MotivoRequerimentoEnumDescricao[valor];
}
